import { render, staticRenderFns } from "./campusRecruit.vue?vue&type=template&id=63fdede8&scoped=true&"
import script from "./campusRecruit.vue?vue&type=script&lang=js&"
export * from "./campusRecruit.vue?vue&type=script&lang=js&"
import style0 from "./campusRecruit.vue?vue&type=style&index=0&id=63fdede8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fdede8",
  null
  
)

export default component.exports